import { config as categoryConfig } from '~/assets/services/category';

const { pageType: categoryPageType } = categoryConfig;
const pageTypesWithDynamicTemplates = [categoryPageType];

export default {
    pageTypesWithDynamicTemplates,
};
